/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { DealerSubventionDto } from '../model/dealerSubventionDto';
import { FinProdInfoDto } from '../model/finProdInfoDto';
import { FinProdLoanDto } from '../model/finProdLoanDto';
import { FinProdLoanPostDto } from '../model/finProdLoanPostDto';
import { IndQuotLoanAssetMapDto } from '../model/indQuotLoanAssetMapDto';
import { IndSubventionRequestDto } from '../model/indSubventionRequestDto';
import { IndSubventionResponseDto } from '../model/indSubventionResponseDto';
import { InsertQuotationDataResponseDto } from '../model/insertQuotationDataResponseDto';
import { ReturnParametersResponse } from '../model/returnParametersResponse';
import { ReturnSubProductsResponse } from '../model/returnSubProductsResponse';
import { ReviewDto } from '../model/reviewDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FinanceControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * calculateSubProductEmi
     * 
     * @param indQuotLoanAssetMapDto indQuotLoanAssetMapDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateSubProductEmiUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'body', reportProgress?: boolean): Observable<ReturnParametersResponse>;
    public calculateSubProductEmiUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReturnParametersResponse>>;
    public calculateSubProductEmiUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReturnParametersResponse>>;
    public calculateSubProductEmiUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (indQuotLoanAssetMapDto === null || indQuotLoanAssetMapDto === undefined) {
            throw new Error('Required parameter indQuotLoanAssetMapDto was null or undefined when calling calculateSubProductEmiUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReturnParametersResponse>(`${this.basePath}/finance/subproduct/emi`,
            indQuotLoanAssetMapDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * calculateSubventionEmi
     * 
     * @param dealerSubventionDto dealerSubventionDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculateSubventionEmiUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'body', reportProgress?: boolean): Observable<ReturnParametersResponse>;
    public calculateSubventionEmiUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReturnParametersResponse>>;
    public calculateSubventionEmiUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReturnParametersResponse>>;
    public calculateSubventionEmiUsingPOST(dealerSubventionDto: DealerSubventionDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dealerSubventionDto === null || dealerSubventionDto === undefined) {
            throw new Error('Required parameter dealerSubventionDto was null or undefined when calling calculateSubventionEmiUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReturnParametersResponse>(`${this.basePath}/finance/subvention/emi`,
            dealerSubventionDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getEmiDetails
     * 
     * @param finProdLoanPostDto finProdLoanPostDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmiDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'body', reportProgress?: boolean): Observable<ReturnParametersResponse>;
    public getEmiDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReturnParametersResponse>>;
    public getEmiDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReturnParametersResponse>>;
    public getEmiDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (finProdLoanPostDto === null || finProdLoanPostDto === undefined) {
            throw new Error('Required parameter finProdLoanPostDto was null or undefined when calling getEmiDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReturnParametersResponse>(`${this.basePath}/finance/loan/emi`,
            finProdLoanPostDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFinProdInfoDetails
     * 
     * @param finProdInfoDto finProdInfoDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFinProdInfoDetailsUsingPOST(finProdInfoDto: FinProdInfoDto, observe?: 'body', reportProgress?: boolean): Observable<FinProdLoanDto>;
    public getFinProdInfoDetailsUsingPOST(finProdInfoDto: FinProdInfoDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FinProdLoanDto>>;
    public getFinProdInfoDetailsUsingPOST(finProdInfoDto: FinProdInfoDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FinProdLoanDto>>;
    public getFinProdInfoDetailsUsingPOST(finProdInfoDto: FinProdInfoDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (finProdInfoDto === null || finProdInfoDto === undefined) {
            throw new Error('Required parameter finProdInfoDto was null or undefined when calling getFinProdInfoDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FinProdLoanDto>(`${this.basePath}/finance/prodInfo`,
            finProdInfoDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFinSplPrgmLoanDetails
     * 
     * @param finProdLoanPostDto finProdLoanPostDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFinSplPrgmLoanDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'body', reportProgress?: boolean): Observable<InsertQuotationDataResponseDto>;
    public getFinSplPrgmLoanDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InsertQuotationDataResponseDto>>;
    public getFinSplPrgmLoanDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InsertQuotationDataResponseDto>>;
    public getFinSplPrgmLoanDetailsUsingPOST(finProdLoanPostDto: FinProdLoanPostDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (finProdLoanPostDto === null || finProdLoanPostDto === undefined) {
            throw new Error('Required parameter finProdLoanPostDto was null or undefined when calling getFinSplPrgmLoanDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<InsertQuotationDataResponseDto>(`${this.basePath}/finance/loan/refid`,
            finProdLoanPostDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSubVentionDetails
     * 
     * @param indSubventionRequest indSubventionRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubVentionDetailsUsingPOST(indSubventionRequest: IndSubventionRequestDto, observe?: 'body', reportProgress?: boolean): Observable<IndSubventionResponseDto>;
    public getSubVentionDetailsUsingPOST(indSubventionRequest: IndSubventionRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IndSubventionResponseDto>>;
    public getSubVentionDetailsUsingPOST(indSubventionRequest: IndSubventionRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IndSubventionResponseDto>>;
    public getSubVentionDetailsUsingPOST(indSubventionRequest: IndSubventionRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (indSubventionRequest === null || indSubventionRequest === undefined) {
            throw new Error('Required parameter indSubventionRequest was null or undefined when calling getSubVentionDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IndSubventionResponseDto>(`${this.basePath}/finance/subvention/details`,
            indSubventionRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveLoanTermsDetails
     * 
     * @param finProdLoanPostDto finProdLoanPostDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveLoanTermsDetailsUsingPOST1(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public saveLoanTermsDetailsUsingPOST1(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public saveLoanTermsDetailsUsingPOST1(finProdLoanPostDto: FinProdLoanPostDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public saveLoanTermsDetailsUsingPOST1(finProdLoanPostDto: FinProdLoanPostDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (finProdLoanPostDto === null || finProdLoanPostDto === undefined) {
            throw new Error('Required parameter finProdLoanPostDto was null or undefined when calling saveLoanTermsDetailsUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/finance/loan`,
            finProdLoanPostDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveSubProdutDeatils
     * 
     * @param indQuotLoanAssetMapDto indQuotLoanAssetMapDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveSubProdutDeatilsUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'body', reportProgress?: boolean): Observable<ReviewDto>;
    public saveSubProdutDeatilsUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReviewDto>>;
    public saveSubProdutDeatilsUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReviewDto>>;
    public saveSubProdutDeatilsUsingPOST(indQuotLoanAssetMapDto: IndQuotLoanAssetMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (indQuotLoanAssetMapDto === null || indQuotLoanAssetMapDto === undefined) {
            throw new Error('Required parameter indQuotLoanAssetMapDto was null or undefined when calling saveSubProdutDeatilsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReviewDto>(`${this.basePath}/finance/subproducts`,
            indQuotLoanAssetMapDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveSubvention
     * 
     * @param dealerSubventionDto dealerSubventionDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveSubventionUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'body', reportProgress?: boolean): Observable<ReturnSubProductsResponse>;
    public saveSubventionUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReturnSubProductsResponse>>;
    public saveSubventionUsingPOST(dealerSubventionDto: DealerSubventionDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReturnSubProductsResponse>>;
    public saveSubventionUsingPOST(dealerSubventionDto: DealerSubventionDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dealerSubventionDto === null || dealerSubventionDto === undefined) {
            throw new Error('Required parameter dealerSubventionDto was null or undefined when calling saveSubventionUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ReturnSubProductsResponse>(`${this.basePath}/finance/subvention`,
            dealerSubventionDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
